require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./driving-gender-balance.json") })
        }
      }, "path---driving-gender-balance");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---driving-gender-balance!./.cache/json/driving-gender-balance.json
// module id = 1085
// module chunks = 231608221292675